"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vDefaultPacks = exports.vDefaultValues = void 0;

var _regex = _interopRequireDefault(require("./regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var vDefaultValues = {
  dates: {
    birthdate: {
      minYear: 1900,
      maxYear: new Date().getFullYear()
    }
  },
  name: {
    fullname: {
      maxlength: 80
    },
    firstname: {
      maxlength: 50
    },
    lastname: {
      maxlength: 50
    },
    preferredName: {
      maxLength: 80
    }
  },
  sessionName: {
    maxlength: 20
  },
  phone: {
    complete: {
      maxlength: 20
    },
    international: {
      maxlength: 20,
      minlength: 7
    }
  },
  email: {
    maxlength: 200
  },
  username: {
    maxlength: 30
  },
  password: {
    maxlength: 1024,
    minlength: 9
  },
  url: {
    maxlength: 2000
  },
  address: {
    address: {
      maxlength: 200
    },
    city: {
      maxlength: 80
    },
    zipcode: {
      maxlength: 10
    }
  },
  card: {
    number: {
      maxlength: 6,
      minlength: 4
    },
    cvv: {
      maxlength: 3,
      minlength: 3
    }
  },
  patientCharacteristics: {
    height: {
      foot: {
        maxvalue: 10,
        minvalue: 1,
        complete: {
          maxlength: 10
        }
      },
      inches: {
        maxvalue: 11,
        minvalue: 0,
        complete: {
          maxvalue: 9 * 12 + 11
        }
      },
      meters: {
        maxlength: 4,
        // if '.' is not removed
        integerPart: {
          maxlength: 1
        },
        fractionalPart: {
          maxlength: 2
        }
      }
    },
    weight: {
      pounds: {
        maxlength: 3
      },
      kg: {
        maxlength: 3
      }
    }
  },
  freeField: {
    maxlength: 25000
  },
  otherInfoField: {
    maxlength: 300
  },
  clinicalRecords: {
    form: {
      name: {
        maxlength: 50
      }
    },
    assessment: {
      subtitle: {
        maxlength: 35
      }
    }
  },
  numbers: {
    maxLength: 10
  },
  file: {
    maxSize: 10,
    referralFile: {
      maxSize: 20,
      validFileTypes: 'application/pdf,image/png,image/jpeg'
    }
  }
};
exports.vDefaultValues = vDefaultValues;
var vDefaultPacks = {
  fullname: {
    validChars: _regex["default"].name.global,
    maxL: vDefaultValues.name.fullname.maxlength
  },
  firstname: {
    validChars: _regex["default"].name.global,
    maxL: vDefaultValues.name.firstname.maxlength
  },
  lastname: {
    validChars: _regex["default"].name.global,
    maxL: vDefaultValues.name.lastname.maxlength
  },
  preferredName: {
    validChars: _regex["default"].preferredName.global,
    maxL: vDefaultValues.name.preferredName.maxLength
  },
  sessionName: {
    validChars: _regex["default"].sessionName.global,
    maxL: vDefaultValues.sessionName.maxlength
  },
  memberId: {
    validChars: _regex["default"].ids.member
  },
  phone: {
    prefixAndPhoneReq: true,
    prefixFormat: true,
    // Checks existence and format of prefix
    phoneNumberFormat: true,
    // Checks existence and format of number
    phoneFormat: true,
    // Checks format of a complete phone number
    maxLengthMinusOffset: [vDefaultValues.phone.complete.maxlength, 2]
  },
  // Bypass double // between prefix and phone
  internationalPhone: {
    internationalPhoneFormat: true,
    minLengthMinusOffset: [vDefaultValues.phone.international.minlength, 2],
    maxLengthMinusOffset: [vDefaultValues.phone.international.maxlength, 2]
  },
  address: {
    maxL: vDefaultValues.address.address.maxlength
  },
  city: {
    maxL: vDefaultValues.address.city.maxlength
  },
  email: {
    maxL: vDefaultValues.email.maxlength,
    email: true
  },
  username: {
    maxL: vDefaultValues.username.maxlength,
    username: true
  },
  heightImperialFeet: {
    validChars: _regex["default"].integers.general,
    maxLimit: vDefaultValues.patientCharacteristics.height.foot.maxvalue,
    minLimit: vDefaultValues.patientCharacteristics.height.foot.minvalue
  },
  heightImperialInches: {
    validChars: _regex["default"].integers.general,
    maxLimit: vDefaultValues.patientCharacteristics.height.inches.maxvalue,
    minLimit: vDefaultValues.patientCharacteristics.height.inches.minvalue
  },
  heightInches: {
    validChars: _regex["default"].integers.general,
    maxV: vDefaultValues.patientCharacteristics.height.inches.complete.maxvalue
  },
  heightMeters: {
    maxLengthOfDecimalNumber: [vDefaultValues.patientCharacteristics.height.meters.integerPart.maxlength, vDefaultValues.patientCharacteristics.height.meters.fractionalPart.maxlength],
    validChars: _regex["default"].floats.general
  },
  weightLb: {
    validChars: _regex["default"].integers.general,
    maxL: vDefaultValues.patientCharacteristics.weight.pounds.maxlength
  },
  weightKg: {
    validChars: _regex["default"].integers.general,
    maxL: vDefaultValues.patientCharacteristics.weight.kg.maxlength
  },
  zipcode: {
    validChars: _regex["default"].zipcode.acceptedChars,
    maxL: vDefaultValues.address.zipcode.maxlength
  },
  password: {
    minL: vDefaultValues.password.minlength,
    maxL: vDefaultValues.password.maxlength
  },
  cardNumber: {
    validChars: _regex["default"].integers.general,
    maxL: vDefaultValues.card.number.maxlength,
    minL: vDefaultValues.card.number.minlength
  },
  cardCvv: {
    validChars: _regex["default"].integers.general,
    maxL: vDefaultValues.card.cvv.maxlength,
    minL: vDefaultValues.card.cvv.minlength
  },
  freeField: {
    maxL: vDefaultValues.freeField.maxlength
  },
  otherInfoField: {
    maxL: vDefaultValues.otherInfoField.maxlength
  },
  date: {
    validDay: true,
    validMonth: true,
    validYear: [vDefaultValues.dates.birthdate.minYear]
  },
  futureDate: {
    validDay: true,
    validMonth: true,
    validYear: [vDefaultValues.dates.birthdate.minYear],
    isFuture: true
  },
  previousDate: {
    validDay: true,
    validMonth: true,
    validYear: [vDefaultValues.dates.birthdate.minYear, vDefaultValues.dates.birthdate.maxYear],
    isNotFuture: true
  },
  numbers: {
    validChars: _regex["default"].integers.general,
    maxL: vDefaultValues.numbers.maxLength
  },
  floatNumbers: {
    validChars: _regex["default"].floats.general,
    maxL: vDefaultValues.numbers.maxLength
  },
  url: {
    url: true,
    maxL: vDefaultValues.url.maxlength
  },
  file: {
    maxFileSize: vDefaultValues.file.maxSize
  },
  referralFile: {
    maxFileSize: vDefaultValues.file.referralFile.maxSize,
    validFileTypes: vDefaultValues.file.referralFile.validFileTypes
  }
};
exports.vDefaultPacks = vDefaultPacks;